import { ActionCommonParamsSchema } from "../../types";

export const ShipinhaoGetMsgParamsSchema = ActionCommonParamsSchema.extend({});
